import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 27.9" {...props}>
      <defs>
        <style>
          {`.st0{fill:none;stroke:${props.color};stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`}
        </style>
      </defs>
      <g id="prefix__Group_2514" transform="translate(-705.193 -383.5)">
        <path
          id="prefix__Path_3565"
          className="st0"
          d="M719,389c-0.6-0.1-1.2,0-1.8,0"
        />
        <path
          id="prefix__Path_3566"
          className="st0"
          d="M712.2,403.3c0.6,0.6,1.3,1.1,2.1,1.5c0,0.8-0.4,1.6-1.1,2c-1.9,1.1-0.5,2.2,0.7,2.5
		s2.9,0.4,2.1-1.6c-0.3-0.8-0.1-1.6,0.3-2.3c0.9,0.2,1.8,0.2,2.6,0.1"
        />
        <path
          id="prefix__Path_3567"
          className="st0"
          d="M711.7,398.6c-0.6,1.2-1.9,2-3.3,1.9c-2.1-0.6-1.8,1.2-1.3,2.3s1.8,2.4,2.6,0.3
		c0.7-1.2,2.1-1.8,3.5-1.6"
        />
        <path
          id="prefix__Path_3568"
          className="st0"
          d="M713.4,392.6c0.3-1.4-0.3-2.9-1.6-3.7c-2.2-0.8-0.5-2.3,0.6-2.9s3.3-1,2.7,1.2
		c-0.2,1.5,0.6,2.9,2,3.5"
        />
        <path
          id="prefix__Path_3569"
          className="st0"
          d="M709.7,398.4c-0.1-0.9-0.1-1.7,0.1-2.6c-0.7-0.5-1.5-0.6-2.3-0.3c-2,0.9-2-0.9-1.6-2.1
		s1.4-2.6,2.5-0.7c0.5,0.7,1.2,1.1,2,1.1c0.4-0.8,0.9-1.5,1.5-2.2"
        />
        <path
          id="prefix__Path_3570"
          className="st0"
          d="M721.9,407.7v-4c0.1-1.3,0.7-2.5,1.7-3.4c0.7-0.9,2.8-3.4,2.8-3.4s-2-2.5-2.8-3.4
		c-1-0.9-1.6-2.1-1.7-3.4v-2.7"
        />
        <path
          id="prefix__Path_3571"
          className="st0"
          d="M733.5,407.7v-4c-0.1-1.3-0.7-2.5-1.7-3.4c-0.7-0.9-2.8-3.4-2.8-3.4s2-2.5,2.8-3.4
		c1-0.9,1.6-2.1,1.7-3.4v-2.7"
        />
        <path
          id="prefix__Path_3572"
          className="st0"
          d="M734.7,384h-14.1v1.9c0,0.7,0.6,1.3,1.3,1.3h11.5c0.7,0,1.3-0.6,1.3-1.3L734.7,384z"
        />
        <path
          id="prefix__Path_3573"
          className="st0"
          d="M733.5,407.7h-11.5c-0.7,0-1.3,0.6-1.3,1.3v1.9h14.1V409
		C734.7,408.3,734.2,407.7,733.5,407.7z"
        />
        <path
          id="prefix__Path_3574"
          className="st0"
          d="M731.5,405.6l-2.5-2.2c-0.7-0.6-1.8-0.6-2.6,0l-2.6,2.4"
        />
        <path id="prefix__Line_522" className="st0" d="M727.7,399.1v1.3" />
      </g>
    </svg>
  );
}

export default SvgComponent;
